/**
 * custom-cart-brinde-dialog.js
 *
 * Opens a <dialog> with product details when a brinde item is clicked
 * in the cart drawer. Uses showModal() so it renders in the top layer,
 * above the cart drawer dialog.
 *
 * Data source: <script type="application/json" class="brinde-item-data">
 *   embedded inside each .cart-brindes__item by custom-cart-brindes.liquid.
 *
 * Dependencies:
 *   - custom-cart.css (dialog styles)
 */

(function () {
  if (window._cartBrindeDialogInit) return;
  window._cartBrindeDialogInit = true;

  // ── SVG icons ──────────────────────────────────────────────────────────────

  const CLOSE_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`;
  const CHEV_L = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>`;
  const CHEV_R = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>`;

  // ── Helpers ────────────────────────────────────────────────────────────────

  function escHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getOrCreateDialog() {
    let dlg = document.getElementById('brinde-detail-dialog');
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.id = 'brinde-detail-dialog';
    dlg.className = 'brinde-dialog';
    document.body.appendChild(dlg);
    return dlg;
  }

  // ── Open ───────────────────────────────────────────────────────────────────

  function openDialog({ title, description, images }) {
    const dlg    = getOrCreateDialog();
    const imgs   = Array.isArray(images) && images.length ? images : [];
    const total  = imgs.length;

    const slideImgs = imgs.length
      ? imgs.map(src => `<div class="swiper-slide"><img class="brinde-dialog__img" src="${escHtml(src)}" alt="${escHtml(title)}" loading="lazy" draggable="false" /></div>`).join('')
      : '';

    dlg.innerHTML = `
      <div class="brinde-dialog__mobile-header">
        <span class="brinde-dialog__mobile-title">Detalhes do Brinde</span>
        <button type="button" class="brinde-dialog__close" aria-label="Fechar">${CLOSE_SVG}</button>
      </div>

      <div class="brinde-dialog__carousel-wrap">
        <div class="swiper brinde-dialog__swiper">
          <div class="swiper-wrapper">${slideImgs}</div>
        </div>
        ${total > 1 ? `
          <button type="button" class="brinde-dialog__nav brinde-dialog__nav--prev" aria-label="Imagem anterior">${CHEV_L}</button>
          <button type="button" class="brinde-dialog__nav brinde-dialog__nav--next" aria-label="Próxima imagem">${CHEV_R}</button>
          <span class="brinde-dialog__counter">1/${total}</span>
          <div class="brinde-dialog__dots swiper-pagination"></div>
        ` : ''}
      </div>

      <div class="brinde-dialog__info">
        <button type="button" class="brinde-dialog__close brinde-dialog__close--desktop" aria-label="Fechar">${CLOSE_SVG}</button>
        <div class="brinde-dialog__head">
          <span class="brinde-dialog__badge">Grátis</span>
          <p class="brinde-dialog__title">${escHtml(title)}</p>
        </div>
        <div class="brinde-dialog__desc-wrap">
          <div class="brinde-dialog__desc rte"></div>
        </div>
      </div>
    `;

    // Set description as HTML (trusted Shopify merchant content)
    const descEl = dlg.querySelector('.brinde-dialog__desc');
    const wrapEl = dlg.querySelector('.brinde-dialog__desc-wrap');
    descEl.innerHTML = description || '';

    // Fade: show only when scrollable and not at the bottom
    function updateFade() {
      const scrollable = descEl.scrollHeight > descEl.clientHeight;
      const atBottom   = descEl.scrollTop + descEl.clientHeight >= descEl.scrollHeight - 2;
      wrapEl.classList.toggle('has-fade', scrollable && !atBottom);
    }

    descEl.addEventListener('scroll', updateFade, { passive: true });
    // Run after showModal() so layout dimensions are available
    requestAnimationFrame(updateFade);

    // Fade for .brinde-dialog__info on mobile
    const infoEl = dlg.querySelector('.brinde-dialog__info');
    function updateInfoFade() {
      const scrollable = infoEl.scrollHeight > infoEl.clientHeight;
      const atBottom   = infoEl.scrollTop + infoEl.clientHeight >= infoEl.scrollHeight - 2;
      infoEl.classList.toggle('has-fade', scrollable && !atBottom);
    }
    infoEl.addEventListener('scroll', updateInfoFade, { passive: true });
    requestAnimationFrame(updateInfoFade);

    // Close buttons
    dlg.querySelectorAll('.brinde-dialog__close').forEach(btn => {
      btn.addEventListener('click', () => dlg.close());
    });

    // Carousel — Swiper
    if (total > 1) {
      const counter = dlg.querySelector('.brinde-dialog__counter');

      const swiper = new Swiper(dlg.querySelector('.brinde-dialog__swiper'), {
        grabCursor: true,
        navigation: {
          prevEl: dlg.querySelector('.brinde-dialog__nav--prev'),
          nextEl: dlg.querySelector('.brinde-dialog__nav--next'),
        },
        pagination: {
          el: dlg.querySelector('.brinde-dialog__dots'),
          clickable: true,
          bulletClass:       'brinde-dialog__dot',
          bulletActiveClass: 'is-active',
        },
        on: {
          slideChange() {
            counter.textContent = `${this.activeIndex + 1}/${total}`;
          },
        },
      });
    }

    dlg.showModal();
  }

  // ── Click delegation ───────────────────────────────────────────────────────

  document.addEventListener('click', function (e) {
    const item = e.target.closest('.cart-brindes__item');
    if (!item) return;

    const dataEl = item.querySelector('.brinde-item-data');
    if (!dataEl) return;

    let data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch {
      return;
    }

    openDialog(data);
  });
})();
